// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getDaysInMonth as fn } from "../getDaysInMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getDaysInMonthWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getDaysInMonthWithOptions;
